/**
 * Dashboard API service
 */
import request from '../utils/request';

export interface CalendarDayData {
  date: string;
  count: number;
  is_overdue: boolean;
  is_today: boolean;
}

export interface DashboardCalendarResponse {
  start_date: string;
  end_date: string;
  calendar_data: CalendarDayData[];
}

export interface FollowUpItem {
  id: number;
  target_type: 'lead' | 'case';
  target_id: number;
  target_name: string;
  next_follow_up_time: string;
  last_follow_up_time: string | null;
  follow_status: string | null;
  is_overdue: boolean;
}

export interface DashboardDayDetail {
  date: string;
  items: FollowUpItem[];
}

export interface DashboardWeekStats {
  week_start: string;
  today_pending_count: number;
  week_followed_count: number;
  week_new_leads_count: number;
  week_new_cases_count: number;
}

export interface DashboardMonthStats {
  month_start: string;
  case_completion_rate: number;
  lead_conversion_rate: number;
}

/**
 * 获取工作台日历数据
 */
export const getDashboardCalendar = async (): Promise<DashboardCalendarResponse> => {
  return request.get('/dashboard/calendar');
};

/**
 * 获取某天的详细待跟进列表
 */
export const getDayDetail = async (targetDate: string): Promise<DashboardDayDetail> => {
  return request.get('/dashboard/day-detail', {
    params: { target_date: targetDate },
  });
};

/**
 * 获取本周统计数据
 */
export const getWeekStats = async (): Promise<DashboardWeekStats> => {
  return request.get('/dashboard/week-stats');
};

/**
 * 获取本月统计数据
 */
export const getMonthStats = async (): Promise<DashboardMonthStats> => {
  return request.get('/dashboard/month-stats');
};
